import { Trans } from '@lingui/react'
import { type Dispatch, type ReactElement, type SetStateAction } from 'react'

import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import { type PageType } from 'types/cmsTypes'
import { type Tenant } from 'types/shopConfig'
import Image from 'views/components/atoms/Image'
import nowLogo from 'views/components/organisms/Cart/NowCollapsible/now_logo.svg'
import { type UserData } from 'views/components/organisms/CmsMobileMenu/types'
import NowZipModalGreenVariant from 'views/components/organisms/NowZipModalGreenVariant'
import { nowGlobalBarClickEvent } from 'views/utils/nowGlobalBar'
import './NowGlobalBarContentGreenVariant.scss'

interface INowGlobalBarContentGreenVariantProps {
  zip: string
  city: string
  setOpenNowZipModal: Dispatch<SetStateAction<boolean>>
  openNowZipModal: boolean
  userData: UserData
  pageType: PageType
  tenant: Tenant
}

const NowGlobalBarContentGreenVariant: (
  props: INowGlobalBarContentGreenVariantProps
) => ReactElement = ({
  zip,
  city,
  setOpenNowZipModal,
  openNowZipModal,
  userData,
  pageType,
  tenant,
}) => {
  const displayUsersData = () => {
    let displayString = ''

    if (zip) {
      displayString = zip

      if (city) {
        displayString += ` ${city}`
      }

      let userSalutations = ''
      if (userData) {
        userSalutations = `${userData?.user?.firstName || ''} ${
          userData?.user?.lastName || ''
        }`
      }

      if (userSalutations && userSalutations !== ' ') {
        displayString = `${userSalutations}, ${displayString}`
      }
    }

    return displayString
  }
  return (
    <>
      <div
        className="l-flex__full-width o-NowGlobalBarContentGreenVariant__content"
        role="button"
        tabIndex={0}
        onClick={() => {
          setOpenNowZipModal(true)
          trackOptimizelyEvent(nowGlobalBarClickEvent(pageType))
        }}
        onKeyDown={undefined}
      >
        <div className="l-content o-NowGlobalBarContentGreenVariant__container">
          <div className="o-NowGlobalBarContentGreenVariant__textContainer">
            <Image
              className="u-margin--small u-padding-small--right o-NowGlobalBarContentGreenVariant__nowLogo"
              src={nowLogo}
            />
            {zip ? (
              <span className="o-NowGlobalBarContentGreenVariant__text">
                <Trans id="general.label.nowGlobalBar.shippingTo" />{' '}
                <strong>{displayUsersData()}</strong>
              </span>
            ) : (
              <span className="o-NowGlobalBarContentGreenVariant__text">
                <Trans id="general.label.nowGlobalBar.enterZipCode" /> &{' '}
                <strong>
                  <Trans id="general.label.nowGlobalBar.enterZipAndFasterShipping" />
                  !
                </strong>
              </span>
            )}
          </div>
        </div>
      </div>
      <NowZipModalGreenVariant
        id="nowZipModal"
        open={openNowZipModal}
        setModalOpen={setOpenNowZipModal}
        zip={zip}
        pageType={pageType}
        tenant={tenant}
      />
    </>
  )
}

export default NowGlobalBarContentGreenVariant
